import type { UserItem, UserListResponse } from "./types"

// format User list
export function formatUserList(response: UserListResponse): UserItem[] {
    return response.results
}

// format user data response 讓用戶資訊符合 routerProtect 需要的格式。
export function formatUserDataToRouterProtectStyle(userDataResponse: { data: UserItem }) {
    return {
        data: {
            creator: {
                department: {
                    name: userDataResponse.data.department,
                    uuid: userDataResponse.data.departmentUuid,
                },
                name: "",
                role: {
                    name: "",
                    slug: "",
                    level: "",
                },
                uuid: "",
            },
            status: userDataResponse.data.status,
        },
    }
}
